module.exports = __webpack_public_path__ + "static/EngraversMT-f3d98212a5fd124474ae99ea8eaedf54.ttf";